import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT = {
  title:
    "NextChapter4You | Executive Coaching & Expat Career Support – Netherlands",
  description:
    "Executive coaching and expat career support in the Netherlands. Human-first coaching for leaders and professionals ready to grow.",
  image: "https://nextchapter4you.nl/logo.svg",
};

const PAGE_META = {
  "/": {
    title:
      "NextChapter4You | Executive Coaching & Expat Career Support – Netherlands",
    description:
      "Executive coaching and expat career support in the Netherlands. Human-first coaching for leaders and professionals ready to grow.",
  },
  "/professional-coaching": {
    title:
      "Executive & Leadership Coaching Netherlands | NextChapter4You",
    description:
      "Executive and leadership coaching in the Netherlands. Confidential human-centred coaching for senior professionals ready to lead with clarity.",
  },
  "/expat-outplacement-support": {
    title: "Expat Outplacement & Career Support Netherlands | NextChapter4You",
    description:
      "Career transition support for expat professionals in the Netherlands. CV LinkedIn interview coaching and Dutch job market guidance with empathy.",
  },
  "/about-us": {
    title: "About NextChapter4You | Coaching & Career Support Netherlands",
    description:
      "Meet Ashutosh Pandey and the human-first coaching and career support philosophy behind NextChapter4You in the Netherlands.",
  },
  "/contact": {
    title: "Contact NextChapter4You | Eindhoven, Netherlands",
    description:
      "Get in touch with NextChapter4You. Reach us by email or phone in Eindhoven, the Netherlands. Free first conversation, replies within one business day.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | NextChapter4You",
    description:
      "How NextChapter4You collects, uses and protects your personal information. GDPR-compliant privacy practices for our Netherlands-based coaching services.",
  },
  "/cookie-policy": {
    title: "Cookie Policy | NextChapter4You",
    description:
      "How NextChapter4You uses cookies and similar technologies on our website. Manage your preferences and learn about our compliance with GDPR.",
  },
  "/terms-conditions": {
    title: "Terms & Conditions | NextChapter4You",
    description:
      "The terms and conditions governing the use of the NextChapter4You website and our coaching and outplacement services.",
  },
};

const SITE_URL = "https://nextchapter4you.nl";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEOHead() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = PAGE_META[pathname] || DEFAULT;
    const url = `${SITE_URL}${pathname}`;
    const image = meta.image || DEFAULT.image;

    document.title = meta.title;
    setMeta("description", meta.description);
    setMeta("robots", "index, follow, max-image-preview:large");

    // Open Graph
    setMeta("og:title", meta.title, "property");
    setMeta("og:description", meta.description, "property");
    setMeta("og:url", url, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", "NextChapter4You", "property");
    setMeta("og:image", image, "property");
    setMeta("og:locale", "en_GB", "property");

    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", meta.title);
    setMeta("twitter:description", meta.description);
    setMeta("twitter:image", image);

    // Canonical
    setLink("canonical", url);
  }, [pathname]);

  return null;
}
